<div class="xvi-custom-text-renderer" [ngClass]="iconConfig?.containerClass">
  <xux-tooltip-icon
    *ngIf="iconConfig"
    [config]="iconConfig"
  ></xux-tooltip-icon>
  <span>{{ value | translate}}</span>
</div>
